const awsmobile = {
  aws_project_region: 'eu-west-1',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_fzEMWiVLk',
  aws_user_pools_web_client_id: '33hoba2nir7dm80d1kvi8lm0ue',
  location_endpoint_auth: 'https://api.optimise-ai.homes/v1/geo-location',
  optimise_endpoint_auth: 'https://api.optimise-ai.homes/v1',
  smartmeter_endpoint_auth: 'https://api.optimise-ai.homes/v1/internal/onboarding',
  billing_endpoint_auth: 'https://api.optimise-ai.homes/v1/internal',
  data_bucket: 'https://loop-optimise-instructions-optimise-branded.s3.eu-west-1.amazonaws.com',
  dashboard_url: 'https://optimise-ai.homes',
  signup_simulation_mode: false,
  theme: 'Utilita',
};
export default awsmobile;
